import { render, staticRenderFns } from "./MoleculeEditionAssetInvitationsModalData.vue?vue&type=template&id=9cf645a6&"
import script from "./MoleculeEditionAssetInvitationsModalData.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetInvitationsModalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports